import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudVolumeBackup = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_backup/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllVolumeBackup = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_volume_backup_list/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudVolumeBackup = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_backup/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudVolumeBackup = (data, id) => {
  let url = privateCloudBaseUrl + 'volume_backup/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    needPrivateCloudProjectHeader: true,
    url: url,
    data: data,
    method: method
  })
}

export const deletePrivateCloudVolumeBackup = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'volume_backup/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
